module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/.6.26.0@babel-runtime/core-js/promise.js
// module id = 153
// module chunks = 0